<template>
  <div class="text-left">
    <div
      class="h2-headline-medium"
      style="line-height: 32px;">
      {{ $t('User.YourBalanceIsLow') }}
    </div>
    <div
      class="h4-headline py-4">
      <div>{{ $t('User.BalanceIsLowReplenishIt.0') }}</div>
      <div>
        {{ $t('User.BalanceIsLowReplenishIt.1') }}
        <span class="bold">{{ (settings.balance*-1)+tariff }}</span> {{ $t('Tenders.WithVAT') }}
      </div>
    </div>
    <div class="py-4">
      <div class="h9-label pb-1">
        {{ $t('User.CurrentBalance') }}
      </div>
      <div
        class="h7-text"
        :class="settings.balance < 0 ? 'text-error' : 'black--text'"
        data-qa="low-balance-page-summ">
        {{ settings.balance }} {{ settings && settings.currency ? settings.currency.shortTitle : $t('Tenders.hrn') }}
      </div>
    </div>
    <div>
      <CreateInvoiceDialog
        data-qa="low-balance-page-create-invoice-btn"
        mode="black-button"/>
    </div>
  </div>
</template>
<script>
import CreateInvoiceDialog from 'components/billing/CreateInvoiceDialog.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'LowBalancePage',
  data() {
    return {
      tariff: 0
    }
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
    }),
  },
  created() {
    this.$store.dispatch('getContractNumberAndTariff')
      .then(res => {
        this.tariff = res?.tariff
      })
  },
  components: {
    CreateInvoiceDialog
  }
}
</script>
